import * as React from 'react'
import { IStageProps } from 'app/types'


export default class HomeStage extends React.Component<IStageProps, {}> {

  render() {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh', flexDirection: 'column'}}>

        <h1 className="home-title">ESCAPE</h1>

        <p className="home-body">Complete the puzzles as quickly as you can. Allow 20 minutes.<br/>You need a keyboard and a mouse (or trackpad).</p>

        <button className="home-button" onClick={this.props.onNext}>Play</button>

      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/home.tsx